import { useQuery } from '@tanstack/react-query';

import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { notificationsKeys } from '../queryKeys.js';

/**
 * The person's notifications in a site, as the server lists them — the one
 * query behind the web bell and the mobile tab. Asked when it mounts and
 * whenever the app is returned to; anyone may have written since, so the last
 * answer is never assumed to hold. Idle until there is a site.
 */
export function useNotifications(siteId: string | null) {
  const { fetchNotifications } = useClientApis().notifications;
  return useQuery({
    queryKey: notificationsKeys.list(siteId ?? ''),
    queryFn: ({ signal }) => fetchNotifications(siteId!, signal),
    enabled: !!siteId,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
